import type PersonalBookingPagePublishingSettings from './schema/PersonalBookingPagePublishingSettings';
import { createStore } from 'owa-satcheljs';
import '../mutators/initializeSettingsMutator';
import type FirstTimePersonalBookingUser from './schema/FirstTimeBookingUserSettings';
import type ServicesRequestStatus from './schema/ServicesRequestStatus';
import type BookWithMeAccessStatusEnum from './schema/BookWithMeAccessStatusEnum';

const initFirstTimeBookingUser: FirstTimePersonalBookingUser = {
    owaCalendarBookingButtonEnabled: false,
    firstTimePersonalBookingUser: false,
};

const initialStore: PersonalBookingPagePublishingSettings = {
    publishingSettings: null,
    isAnonymousSharingEnabled: false,
    firstTimeUserSettings: initFirstTimeBookingUser,
    getMeetingTypeExtensionRequestStatus: 0,
    bookWithMeAccessStatus: 'NotInitiated',
};

const defaultExport: () => PersonalBookingPagePublishingSettings =
    createStore<PersonalBookingPagePublishingSettings>(
        'personalBookingPagePublishingSettings',
        initialStore
    );
export default defaultExport;
